import { BreadcrumbModel } from '@abb-procure/data';
import { BooleanInput } from '@angular/cdk/coercion';
import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  input,
} from '@angular/core';
import { Breadcrumbs } from '../breadcrumbs/breadcrumbs.component';

@Component({
  selector: 'procure-page-header-topbar',
  templateUrl: './page-header-topbar.component.html',
  styleUrl: './page-header-topbar.component.scss',
  imports: [Breadcrumbs],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageHeaderTopbar {
  readonly breadcrumbs = input.required<BreadcrumbModel[] | null>();
  readonly url = input<string | null>();
  readonly sapAribaLink = input<string | null>();
  readonly orbisLink = input<string | null>();
  readonly sncrpLink = input<string | null>();
  readonly gravityLink = input<string | null>();
  readonly xapienLink = input<string | null>();
  readonly ecoVadisLink = input<string | null>();

  readonly entityClickable = input<boolean, BooleanInput>(true, {
    transform: booleanAttribute,
  });
}
